import React, { useEffect, useState } from 'react'
import Header from './header/Header'
import fetchFactory from '../../utils/fetchFactory'
import { ContractsModel } from '../../types/contracts/contractsModel'
import Summary from './summary/Summary'
import { useLocation } from 'react-router'
import { connect } from 'react-redux'
import errorCatcher from '../../utils/errorCatcher'
import Loader from '../../components/loader/Loader'
import ContractsSubMenu from './contracts_body/ContractsSubmenu'
import { convertContractList } from './contractMapper'
import contractsTabEnum from '../../enums/contractsTabEnum'

interface Store {
	errorCatcher: (error: any, id: string) => void
}

const CONTRACT = 'contract'
const TAB = 'tab'

type ContractsProps = Store

const Contracts: React.FC<ContractsProps> = (
	{
		errorCatcher
	}
) => {
	const [contracts, setContracts] = useState<ContractsModel[]>([])
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const [selectedContract, setSelectedContract] = useState<ContractsModel | null>(null)
	//selectedTab = 0 for Account Tab or 1 for Documents
	const [selectedTab, setSelectedTab] = useState(contractsTabEnum.accountTab)

	const location = useLocation()

	useEffect(
		() => {
			fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/contrat/getBaux`)
				.then(
					(contracts: any) => {
						const finalContracts: ContractsModel[] = convertContractList(contracts)
						setContracts(finalContracts)
						setSelectedContract(finalContracts[0])
					}
				)
				.catch(
					(error) => {
						errorCatcher(error, CONTRACT)
					}
				)
				.finally(
					() => setIsLoading(false)
				)
		}, [errorCatcher]
	)

	useEffect(
		() => {
			const data = location.search.split('&')
			const getSelectedContract = data[0].substr(1).split('=')
			if (getSelectedContract.length > 1) {
				if (getSelectedContract[1]) {
					if (getSelectedContract[0] === CONTRACT) {
						const index = contracts.findIndex(
							(a) => a.id === getSelectedContract[1]
						)

						if (index >= 0) {
							setSelectedContract(contracts[index])
						}
					}
				}
			}

			if (data.length > 1) {
				const getSelectedTab = data[1].substr(1).split('=')
				if (getSelectedTab[0] === TAB) {
					setSelectedTab(Number(getSelectedTab[1]))
				}
			}
		}, [contracts, location.search, selectedContract]
	)

	return (
		<>
			{
				!isLoading && contracts.length > 0 && selectedContract &&
				<>
					<Header
						contracts={contracts}
						selectedContract={selectedContract}
					/>

					<Summary contract={selectedContract} />
					<ContractsSubMenu contract={selectedContract} selectedTab={selectedTab} />
				</>
			}
			{
				isLoading &&
				<Loader />
			}
		</>
	)
}

const mapDispatchToProps = { errorCatcher }

export default connect(null, mapDispatchToProps)(Contracts)
